<template>
    <div class="notifications">
        <a-popover
            trigger="click"
            placement="bottom"
        >
            <img src="@/assets/images/alerts-off.svg" alt="Notifications" />
            <span v-if="unreadNotifications.length > 0" class="unread-items-count">
                {{ unreadNotifications.length }}
            </span>
            <template #content>
                <div class="popover-content" v-if="notifications.length > 0">
                    <a-row v-if="unreadNotifications.length > 0">
                        <a-col :xs="12">
                            <span class="unread-items-count-label">{{ unreadNotifications.length }} notifications</span>
                        </a-col>
                        <a-col :xs="12" class="see-all-block">
                            <a-button
                                v-if="unreadNotifications.length > 0 && !isMarkingAsReadAll"
                                @click="markAsReadAll"
                                class="see-all-button"
                            >
                                Mark all as read
                            </a-button>
                            <div
                                v-if="isMarkingAsReadAll"
                                class="loading-label"
                            >
                                Loading...
                            </div>
                        </a-col>
                    </a-row>
                </div>
                <div class="popover-content" v-if="dismissedNotifications.length > 0">
                    <a-row class="dismissed-notification-items">
                        <a-collapse>
                            <a-collapse-panel>
                                <template #header>
                                    Prior Notifications
                                </template>
                                <list :notifications="dismissedNotifications" :showDismissButton="false"></list>
                            </a-collapse-panel>
                        </a-collapse>
                    </a-row>
                </div>
                <div class="popover-content" v-if="notifications.length > 0">
                    <a-row class="notification-items">
                        <list :notifications="notifications"></list>
                    </a-row>
                </div>
                <div class="popover-content-center" v-if="notifications.length === 0">
                    No Notifications
                </div>
            </template>
        </a-popover>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import List from './List.vue';

export default {
    components: {
        List
    },

    data() {
        return {
            isMarkingAsReadAll: false,
            markingIds: []
        };
    },

    computed: {
        ...mapGetters({
            notifications: 'notifications/items',
            dismissedNotifications: 'notifications/dismissedItems',
            unreadNotifications: 'notifications/unreadItems',
            currentSharedLink: 'dashboard/sharedLinks/currentLink'
        })
    },

    async mounted() {
        try {
            const user = await this.validateUser();

            if (user && !this.currentSharedLink) {
                await this.getNotifications();
            }
        } catch (error) {
            // A guest gets an expected 401 while validating - there is nothing to notify about.
            console.warn('We were not able to load notifications.', error);
        }
    },

    methods: {
        ...mapActions({
            getNotifications: 'notifications/getItems',
            markAsRead: 'notifications/markAsRead',
            validateUser: 'auth/validate'
        }),

        async markAsReadAll() {
            try {
                this.isMarkingAsReadAll = true;
                await this.markAsRead({
                    ids: this.unreadNotifications.map(notification => notification.id)
                });
            } catch (error) {
                console.error(error);

                this.$toasterError('We were not able to mark all notification as read.');
            } finally {
                this.isMarkingAsReadAll = false;
            }
        }
    }
};
</script>

<style lang="scss">
.ant-popover-inner-content {
    overflow: auto;
    max-height: 350px;
}

.dismissed-notification-items {
    border-bottom: 1px solid #E6ECF2;

    .ant-collapse {
        .ant-collapse-header {
            padding: 0 0 5px 15px !important;
            background: #FFF;
            .ant-collapse-arrow {
               left: 0 !important;
               top: 11px !important;
            }
        }
        .ant-collapse-content {
            border: 0;
            .ant-collapse-content-box {
                padding: 0;
            }
        }
    }
}
</style>

<style lang="scss" scoped>
.notifications {
    margin-left: 15px;
    cursor: pointer;
}

.notification-items {
    overflow: scroll;
    max-height: 350px;
    position: relative;
}

.unread-items-count {
    margin-top: 11px;
    line-height: 13px;
    margin-left: 22px;
    top: 0;
    display: block;
    position: absolute;
    font-size: 10px;
    font-weight: 600;
    color: #FFFFFF;
    padding: 1px 5px 1px 5px;
    border-radius: 4px;
    background: #FB5050;
}

.popover-content {
    width: 360px;

    .loading-label {
        color: #7A8792;
    }
}

.popover-content-center {
    width: 360px;
    text-align: center;
    padding: 12px;
}

.unread-items-count-label {
    color: #FB5050;
}

.see-all-block {
    text-align: right;
}

.see-all-button {
    color: #7A8792;
    padding: 0;
    height: 0;
    box-shadow: none;
    border: 0;
}

.dismissed-notification-items {
    .ant-collapse {
        width: 100%;
        border: 0;
        .ant-collapse-item {
            border: 0;
        }
    }
}
</style>
